import type {
	LocalColumn,
	ScheduleColumn,
	ScheduleColumnType,
} from "./schedule-of-rates.types";

export const COLUMN_TYPE_LABELS: Record<ScheduleColumnType, string> = {
	text: "Text",
	unit_of_measurement: "Unit",
	number: "Number",
	currency: "Currency",
};

export const COLUMN_TYPE_OPTIONS: { label: string; value: ScheduleColumnType }[] = [
	{ value: "text", label: "Text Column" },
	{ value: "unit_of_measurement", label: "Unit of Measurement Column" },
	{ value: "number", label: "Number Column" },
	{ value: "currency", label: "Currency Column" },
];

export const SCHEDULE_CELL_BORDER = "border border-[#EAECF0]";

export const SCHEDULE_SAMPLE_LABELS: Record<ScheduleColumnType, string> = {
	text: "{text}",
	unit_of_measurement: "{unit}",
	number: "{number}",
	currency: "$0.00",
};

let localColumnCounter = 0;

export const generateLocalColumnId = (): string => {
	localColumnCounter += 1;
	return `schedule-col-${localColumnCounter}-${Date.now()}`;
};

export const generateRowId = (): number => {
	return -Math.floor(Math.random() * 1_000_000_000);
};

export const generateSortId = (columns: ScheduleColumn[]): number => {
	if (columns.length === 0) {
		return 1;
	}
	return Math.max(...columns.map((c) => c.sortOrder)) + 1;
};

export const formatCurrencyValue = (value: string): string => {
	const num = parseFloat(value);
	if (isNaN(num)) {
		return value;
	}
	return num.toFixed(2);
};

export const toLocalColumns = (columns: ScheduleColumn[]): LocalColumn[] => {
	return columns.map((col) => ({
		...col,
		localId: generateLocalColumnId(),
	}));
};

export const fromLocalColumns = (columns: LocalColumn[]): ScheduleColumn[] => {
	return columns.map((col, idx) => ({
		id: col.id,
		label: col.label,
		columnType: col.columnType,
		sortOrder: idx + 1,
	}));
};
